/* eslint-disable import/prefer-default-export */

export const LABELS = {
  SIMILAR_PROPERTIES_TITLE: 'We found some more properties you may be interested in',
  SIMILAR_PROPERTIES_SUBTITLE:
    'Quickly add them to your application or tap the property card for more details',
};
